export function validateLatex(text = "") {
  if (!text) return null;

  const errors = [];

  // 1️⃣ Unmatched $
  const dollarCount = (text.match(/\$/g) || []).length;
  if (dollarCount % 2 !== 0) {
    errors.push("Unmatched $ symbol");
  }

  // 2️⃣ Unmatched braces
  let balance = 0;
  for (const ch of text) {
    if (ch === "{") balance++;
    if (ch === "}") balance--;
    if (balance < 0) break;
  }
  if (balance !== 0) {
    errors.push("Unmatched { } braces");
  }

  // 3️⃣ Forbidden shorthand (NO guessing)
  const forbidden = [
    /\bfrac\d+\d+\b/,     // frac35
    /\bsqrt\d+\b/,        // sqrt144
    /times10\^-?\d+/,     // times10^-4
    /\blog\d+[a-zA-Z]/,   // log7a
  ];

  forbidden.forEach((rx) => {
    if (rx.test(text)) {
      errors.push("Invalid LaTeX shorthand detected");
    }
  });

  return errors.length ? errors : null;
}
